'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoVolumeHigh = function IoVolumeHigh(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15.5 31.9l-7.4-6.9h-8.1v-10h8.1l7.4-6.9v23.8z m4.4-4.1l-1.5-1.2c1.3-1.9 2.1-4.1 2.1-6.6s-0.8-4.7-2.1-6.6l1.5-1.2c1.6 2.2 2.6 4.9 2.6 7.8s-1 5.6-2.6 7.8z m5.3 3.6l-1.7-1.2c2.1-2.9 3.4-6.4 3.4-10.2s-1.3-7.3-3.4-10.2l1.7-1.2c2.3 3.2 3.7 7.1 3.7 11.4s-1.4 8.2-3.7 11.4z m3.3-25.2l1.6-1.2c3 4.2 4.9 9.4 4.9 15s-1.9 10.8-4.9 15l-1.6-1.2c2.8-3.8 4.5-8.6 4.5-13.8s-1.7-10-4.5-13.8z' })
        )
    );
};

exports.default = IoVolumeHigh;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/volume-high.js
// module id = 2551
// module chunks = 0